const axios = require('axios');


/**
 * Update or create Purchase
 * Item can be table, category or menu depending on type variable
 * @param product
 */
export function updatePurchase(purchase) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem " + JSON.stringify(purchase));
    axios.post(process.env.ROOT_API + 'purchase', JSON.stringify(purchase), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Purchase Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}

/**
 * GEt Purchase Items
 */
export function getPurchases(from, to, state = -1) {
  return new Promise(function(resolve, reject) {
    console.log("getPurchases ")
    axios.get(process.env.ROOT_API + 'purchases?from=' + from + "&to=" + to + "&state=" + state, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Purchase Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}

/**
 * Delete purchase Item. This will delete all child stock items
 * @param pId
 * @returns {Promise<unknown>}
 */
export function deletePurchase(pId) {
  return new Promise(function(resolve, reject){
    axios.get(process.env.ROOT_API + 'purchase/delete?id='+pId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(err){
      reject(err);
    })

  })
}



// WEBPACK FOOTER //
// ./src/api/purchase.js